module.exports = __webpack_public_path__ + "img/zhuji.8bdbf042.png";